module.exports = __webpack_public_path__ + "static/img/zhong11.78e3fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong11.png
// module id = YmF+
// module chunks = 16